import { createIcon } from "@illa-design/react"

export const UpgradeIcon = createIcon({
  title: "UpgradeIcon",
  viewBox: "0 0 12 12",
  path: (
    <>
      <g clipPath="url(#clip0_3275_21608)">
        <path
          d="M6 5V11M6 5L3.5 7.5M6 5L8.5 7.5"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 2L9.5 3.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 2L2.5 3.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 1V3"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3275_21608">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
})

UpgradeIcon.displayName = "UpgradeIcon"
